/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PriceUnitData } from './PriceUnitData';
import {
    PriceUnitDataFromJSON,
    PriceUnitDataFromJSONTyped,
    PriceUnitDataToJSON,
} from './PriceUnitData';

/**
 * 
 * @export
 * @interface PriceData
 */
export interface PriceData {
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    currencyIso?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceData
     */
    value?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    priceType?: PriceDataPriceTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    formattedValue?: string;
    /**
     * 
     * @type {number}
     * @memberof PriceData
     */
    minQuantity?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceData
     */
    maxQuantity?: number;
    /**
     * 
     * @type {PriceUnitData}
     * @memberof PriceData
     */
    sapUnit?: PriceUnitData;
    /**
     * 
     * @type {string}
     * @memberof PriceData
     */
    campaignCode?: string;
}


/**
 * @export
 */
export const PriceDataPriceTypeEnum = {
    Buy: 'BUY',
    From: 'FROM',
    Base: 'BASE',
    Scaled: 'SCALED',
    Contract: 'CONTRACT',
    DiscountNormal: 'DISCOUNT_NORMAL',
    DiscountCampaign: 'DISCOUNT_CAMPAIGN',
    DiscountScaledcampaign: 'DISCOUNT_SCALEDCAMPAIGN',
    DiscountPromotion: 'DISCOUNT_PROMOTION'
} as const;
export type PriceDataPriceTypeEnum = typeof PriceDataPriceTypeEnum[keyof typeof PriceDataPriceTypeEnum];


/**
 * Check if a given object implements the PriceData interface.
 */
export function instanceOfPriceData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PriceDataFromJSON(json: any): PriceData {
    return PriceDataFromJSONTyped(json, false);
}

export function PriceDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currencyIso': !exists(json, 'currencyIso') ? undefined : json['currencyIso'],
        'value': !exists(json, 'value') ? undefined : json['value'],
        'priceType': !exists(json, 'priceType') ? undefined : json['priceType'],
        'formattedValue': !exists(json, 'formattedValue') ? undefined : json['formattedValue'],
        'minQuantity': !exists(json, 'minQuantity') ? undefined : json['minQuantity'],
        'maxQuantity': !exists(json, 'maxQuantity') ? undefined : json['maxQuantity'],
        'sapUnit': !exists(json, 'sapUnit') ? undefined : PriceUnitDataFromJSON(json['sapUnit']),
        'campaignCode': !exists(json, 'campaignCode') ? undefined : json['campaignCode'],
    };
}

export function PriceDataToJSON(value?: PriceData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currencyIso': value.currencyIso,
        'value': value.value,
        'priceType': value.priceType,
        'formattedValue': value.formattedValue,
        'minQuantity': value.minQuantity,
        'maxQuantity': value.maxQuantity,
        'sapUnit': PriceUnitDataToJSON(value.sapUnit),
        'campaignCode': value.campaignCode,
    };
}

